import { render, staticRenderFns } from "./customer_show.vue?vue&type=template&id=1d497c6a&"
import script from "./customer_show.vue?vue&type=script&lang=js&"
export * from "./customer_show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports